// Module
var code = "<h2 id=\"private-education-loans\">Private Education Loans</h2> <p>If you have private education loans and need more information about repayment plans or if the use of a deferment or forbearance is right for you, please contact us.</p> ";
// Exports
export default code;